import { useState } from 'react';
import { useSelector } from 'react-redux';
import { updateCredencialRdp } from '../../helpers/api_helper';

const useUpdateCredencialRdp = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const tenantId = useSelector((state) => state.Context.tenantId);

    const updateCredencialRdpHook = async (id, data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await updateCredencialRdp(tenantId, id, data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to update Credencial RDP: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { updateCredencialRdp: updateCredencialRdpHook, loading, error };
};

export default useUpdateCredencialRdp;
